/** @format */
import { getColor } from '@mpb-com/feather/components/atoms/heading/style-helpers';
import { css } from 'styled-components';

import { StyledBlockTitleProps } from './types';

export const styles = ({ headingColor }: StyledBlockTitleProps) => css`
    .pretitle {
        color: ${getColor(headingColor)};
        .skeleton {
            width: 10rem;
        }
    }

    .title {
        margin: 0;
        .skeleton {
            width: 20rem;
        }
    }
`;
